import React from 'react';
import { useStore } from 'zustand';

import { inventoryStore } from '../../../InventoryStore';
import { PackType } from '../../Header/ActionsBar/InventoryToggle/InventoryToggle';

import { MaxBookingDrawer } from './MaxBookingDrawer/MaxBookingDrawer';
import { PackView } from './PackView';

export const PacksTab: React.FC = () => {
  const packType = useStore(inventoryStore, (state) => state.packType);

  return (
    <>
      <PackView isDaytime={packType === PackType.DAYTIME} />
      <MaxBookingDrawer />
    </>
  );
};
